import './index.less'
import WidgetCard from '../../../../../components/WidgetCard'
import { CustomAccessToIcon } from '../../../components/coloredIcons'
import { RootState } from '../../../../../rootReducer'
import { IRoleDetails, PermissionGroup, PermissionModules } from '../../../constants'
import { hereLinkButton } from '../widgetPermissionAccess'
import CustomAccessTable from '../customAccessTable'
import CustomAccessGroupedTable from '../customAccessGroupedTable'
import { useIntl } from 'react-intl'
import { Typography } from '@lightbeamai/design-system'
import React, { useMemo } from 'react'
import { connect } from 'react-redux'

interface IProps {
  isDetailsView: boolean
  roleDetails: IRoleDetails
}
const WidgetCustomPermissionAccess = (props: IProps) => {
  const { isDetailsView, roleDetails } = props
  const intl = useIntl()

  const permissions = useMemo(() => roleDetails.permissions || [], [roleDetails.permissions])

  const groupObjects = useMemo(() => {
    return (
      permissions?.filter(
        ({ permissionName }) => permissionName === PermissionModules.OBJECT_VIEWER
      ) || []
    )
  }, [permissions])

  const groupPolicies = useMemo(() => {
    return (
      permissions?.filter(({ permissionGroup }) => permissionGroup === PermissionGroup.POLICIES) ||
      []
    )
  }, [permissions])

  const groupInsights = useMemo(() => {
    return (
      permissions?.filter(({ permissionGroup }) => permissionGroup === PermissionGroup.INSIGHTS) ||
      []
    )
  }, [permissions])

  const groupAdministration = useMemo(() => {
    return (
      permissions?.filter(
        ({ permissionGroup }) => permissionGroup === PermissionGroup.ADMINISTRATION
      ) || []
    )
  }, [permissions])

  const groupPrivacyOps = useMemo(() => {
    return (
      permissions?.filter(
        (perm) =>
          perm.permissionGroup === PermissionGroup.PRIVACY_OPS &&
          !perm.permissionName.startsWith('privacy-ops')
      ) || []
    )
  }, [permissions])

  const groupOthers = useMemo(() => {
    return (
      permissions?.filter(
        (perm) =>
          perm.permissionGroup === PermissionGroup.PRIVACY_OPS &&
          perm.permissionName.startsWith('privacy-ops')
      ) || []
    )
  }, [permissions])

  return (
    <div className="xs-mb-32 widget-permission-access-container widget-custom-permissions">
      {!!groupObjects.length && (
        <WidgetCard
          cardBordered={true}
          widgetTitle={{
            title: intl.formatMessage({
              id: 'settings.roles.widget.title.customAccess.objects'
            }),
            bordered: true,
            icon: <CustomAccessToIcon />
          }}
          className="xs-mt-32"
        >
          <CustomAccessTable permissions={groupObjects} isDetailsView={isDetailsView} />
        </WidgetCard>
      )}
      {!!groupPolicies.length && (
        <WidgetCard
          cardBordered={true}
          widgetTitle={{
            title: intl.formatMessage({
              id: 'settings.roles.widget.title.customAccess.policiesAndAlerts'
            }),
            bordered: true,
            icon: <CustomAccessToIcon />
          }}
          className="xs-mt-32"
        >
          <Typography as="span" type={'medium'}>
            {intl.formatMessage({
              id: 'settings.roles.widget.info.customRole.policiesAndAlerts'
            })}
            {hereLinkButton}
          </Typography>
          <CustomAccessTable permissions={groupPolicies} isDetailsView={isDetailsView} />
        </WidgetCard>
      )}
      {!!groupInsights.length && (
        <WidgetCard
          cardBordered={true}
          widgetTitle={{
            title: intl.formatMessage({
              id: 'settings.roles.widget.title.customAccess.insights'
            }),
            bordered: true,
            icon: <CustomAccessToIcon />
          }}
          className="xs-mt-32"
        >
          <Typography as="span" type={'medium'}>
            {intl.formatMessage({
              id: 'settings.roles.widget.info.customRole.insights'
            })}
            {hereLinkButton}
          </Typography>
          <CustomAccessTable permissions={groupInsights} isDetailsView={isDetailsView} />
        </WidgetCard>
      )}
      {!!groupAdministration.length && (
        <WidgetCard
          cardBordered={true}
          widgetTitle={{
            title: intl.formatMessage({
              id: 'settings.roles.widget.title.customAccess.administration'
            }),
            bordered: true,
            icon: <CustomAccessToIcon />
          }}
          className="xs-mt-32"
        >
          <Typography as="span" type={'medium'}>
            {intl.formatMessage({
              id: 'settings.roles.widget.info.customRole.administration'
            })}
            {hereLinkButton}
          </Typography>
          <CustomAccessTable permissions={groupAdministration} isDetailsView={isDetailsView} />
        </WidgetCard>
      )}
      <WidgetCard
        cardBordered={true}
        widgetTitle={{
          title: intl.formatMessage({
            id: 'settings.roles.widget.title.customAccess.privacyOpsModules'
          }),
          bordered: true,
          icon: <CustomAccessToIcon />
        }}
        className="xs-mt-32"
      >
        <Typography as="span" type={'medium'}>
          {intl.formatMessage({
            id: 'settings.roles.widget.info.customRole.privacyOpsModules'
          })}
          {hereLinkButton}
        </Typography>
        <CustomAccessTable
          permissions={groupPrivacyOps}
          isDetailsView={isDetailsView}
          tableHeader={intl.formatMessage({
            id: 'settings.roles.table.column.moduleAction.ropaPia'
          })}
        />
        <CustomAccessGroupedTable
          permissions={groupOthers}
          isDetailsView={isDetailsView}
          tableHeader={intl.formatMessage({
            id: 'settings.roles.table.column.moduleAction.others'
          })}
        />
      </WidgetCard>
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  roleDetails: state.configureRoles.roleDetails
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(WidgetCustomPermissionAccess)
